﻿import $ from 'jquery';

(function (window, $) {
    "use strict";

    $(function () {
        //Header Navbar V2 size
        var popupV2ContainerWidth;
        var categoriesPopupV2NavWidth = 230;
        var categoriesPopupV2 = $(".header-v2 .navbar-list__popup");

        setTimeout(function () {
            popupV2ContainerWidth = $('.header-v2__navbar .header-navbar-flex').width();
            categoriesPopupV2.width(popupV2ContainerWidth - categoriesPopupV2NavWidth);
        },
            100);

        window.onresize = function (event) {
            popupV2ContainerWidth = $('.header-v2__navbar .header-navbar-flex').width();
            categoriesPopupV2.width(popupV2ContainerWidth - categoriesPopupV2NavWidth);
        }

        //Header Navbar Quintessence size
        var categoriesPopupQuin = $(".header-quin .navbar-list__popup");

        setTimeout(function () {
            popupV2ContainerWidth = $('.header-quin__navbar .header-navbar-flex').width();
            categoriesPopupQuin.width(popupV2ContainerWidth - categoriesPopupV2NavWidth);
        },
            100);

        window.onresize = function (event) {
            popupV2ContainerWidth = $('.header-quin__navbar .header-navbar-flex').width();
            categoriesPopupQuin.width(popupV2ContainerWidth - categoriesPopupV2NavWidth);
        };   

        $(window).scroll(function() {
            var scroll = $(window).scrollTop();
            if (scroll >= 220) {
                $("header.fixed").addClass("smaller");
            } else {
                $("header.fixed").removeClass("smaller");
            }
        });

        $('.slick-init').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.sliding-tabs-init .tabs-nav__button').click(function (e) {
            e.preventDefault();
            var targetElement = $(this).attr('href');
            var headOffset = 50;
            if ($("header").hasClass('fixed')) {
                headOffset = $('header').height() + 20;
            }
            $('html, body').animate({
                scrollTop: $(targetElement).offset().top - headOffset
            }, 200);
        });

        $('.header__navbar .navbar-list__item').mouseover(function () {
            $(this).children(".navbar-list__link").addClass("configurable-header-mainmenuhover");
        });
        $('.header__navbar .navbar-list__item').mouseleave(function () {
            $(this).children(".navbar-list__link").removeClass("configurable-header-mainmenuhover");
        });

        $('.header-v2__navbar .categories-toggle').mouseover(function () {
            $(this).addClass("configurable-header-mainmenuhover");
        });
        $('.header-v2__navbar .categories-toggle').mouseleave(function () {
            $(this).removeClass("configurable-header-mainmenuhover");
        });

        $('.header-v3-main__navbar .categories-toggle').mouseover(function () {
            $(this).addClass("configurable-header-mainmenuhover");
        });
        $('.header-v3-main__navbar .categories-toggle').mouseleave(function () {
            $(this).removeClass("configurable-header-mainmenuhover");
        });

        $('.category-tree-toggle').click(function () {
            $(this).toggleClass('open');
            $('.category-tree-popup-list>ul').slideToggle('fast');
        });

        $('.categories-toggle').click(function () {
            $(this).toggleClass('open');
            $('.categories-popup').slideToggle('fast');
        });

        $('.header-selector__button').click(function () {
            $(this).toggleClass('open');
            $(this).parent().children('.header-selector__dropdown').slideToggle('fast');
        });

        $('.header-selector-comteam__button').click(function () {
            $(this).toggleClass('open');
            $(this).parent().children('.header-selector-comteam__dropdown').slideToggle('fast');
        });

        $('.settings-toggler').click(function () {
            $(this).toggleClass('open');
            $('.header-v3-main__settings').slideToggle('fast');
        });

        $('.header-toggler').click(function () {
            $(this).toggleClass('open');
            if ($('.search-toggler').hasClass('open')) {
                $('.search-toggler').removeClass('open');
            } else {
                $('body').toggleClass('doc-not-scrollable');
            }
            $('#header-search-box').removeClass('open');
            $('.mobilemenu').toggleClass('mobilemenu--open');
        });

        $('.mobilemenu__close').click(function () {
            $('.header-toggler').removeClass('open');
            $('body').removeClass('doc-not-scrollable');
            $('.mobilemenu').removeClass('mobilemenu--open');
        });

        $('.search-toggler').click(function () {
            $(this).toggleClass('open');
            if ($('.header-toggler').hasClass('open')) {
                $('.header-toggler').removeClass('open');
            } else {
                $('body').toggleClass('doc-not-scrollable');
            }
            $('#header-search-box').toggleClass('open');
        });

        $('.navbar-list__toggler').click(function () {
            $(this).parent().toggleClass('open');
            $(this).parent().children('.second-level').toggleClass('open');
        });

        if ($('.header-toggler').hasClass('open') || $('.search-toggler').hasClass('open')) {
            $('body').addClass('doc-not-scrollable');
        }

        $('.subcategories-region__toggle').click(function () {
            $(this).toggleClass('open');
            $(this).parent().children('.subcategories').slideToggle('fast');
        });

        $(".header-quintessence .header-quin-main__settings-toggle").click(function () {
            $(".header-quintessence .header-quin-main__settings").slideToggle('fast');
        });

        $(".header-quintessence .header-control--search").click(function () {
            $(".header-quintessence .header-quin__navbar").slideToggle('fast');
        });

        $(".header-quintessence .search__close").click(function () {
            $(".header-quintessence .header-quin__navbar").slideToggle('fast');
        });

        document.addEventListener("click", e => {
            const selectorPopup = document.querySelector(".header-quin-main__settings");
            const selectorPopupToggle = document.querySelector(".header-quin-main__settings-toggle");

            if (e.target != selectorPopupToggle) {
                if ($(selectorPopup).css('display') == 'block') {
                    $(selectorPopup).slideToggle('fast');
                }
            }

            const catPopup = document.querySelector(".categories-popup");
            const catPopupToggle = document.querySelector(".categories-toggle");

            if (e.target != catPopupToggle) {
                if ($(catPopup).css('display') == 'block') {
                    $(catPopup).slideToggle('fast');
                    $(catPopupToggle).removeClass('open');
                }
            }

        });

    });
}(window, $));
